import { AudioFormat } from '../../device-api/audio-format';
export var AndroidTvEvent;
(function (AndroidTvEvent) {
    AndroidTvEvent["AdBreakData"] = "adBreakData";
    AndroidTvEvent["AdBreakEnded"] = "adBreakEnded";
    AndroidTvEvent["AdBreakStarted"] = "adBreakStarted";
    AndroidTvEvent["AdEnded"] = "adEnded";
    AndroidTvEvent["AdPositionUpdate"] = "adPositionUpdate";
    AndroidTvEvent["AdSkipped"] = "adSkipped";
    AndroidTvEvent["AdStarted"] = "adStarted";
    AndroidTvEvent["AvailableAudioTracks"] = "availableAudioTracks";
    AndroidTvEvent["AvailableSubtitleTracks"] = "availableSubtitleTracks";
    AndroidTvEvent["Bitrate"] = "bitrate";
    AndroidTvEvent["CurrentAudioTrack"] = "currentAudioTrack";
    AndroidTvEvent["CurrentSubtitleTrack"] = "currentSubtitleTrack";
    AndroidTvEvent["DebugPlayerEvent"] = "debugPlayerEvent";
    AndroidTvEvent["Deeplink"] = "deeplink";
    AndroidTvEvent["Duration"] = "duration";
    AndroidTvEvent["Error"] = "error";
    AndroidTvEvent["EstimatedBandwidthBps"] = "estimatedBandwidthBps";
    AndroidTvEvent["Framerate"] = "framerate";
    AndroidTvEvent["Lifecycle"] = "lifecycle";
    AndroidTvEvent["ManifestAdsReceived"] = "manifestAdsReceived";
    AndroidTvEvent["MediaRouteInfoEvent"] = "mediaRouteInfoEvent";
    AndroidTvEvent["NonLinearAds"] = "nonLinearAds";
    AndroidTvEvent["OnAvailableThumbnailStreamsChanged"] = "onAvailableThumbnailStreamsChanged";
    AndroidTvEvent["OnTelemetryData"] = "onTelemetryData";
    AndroidTvEvent["PlaybackTimelineChanged"] = "playbackTimelineChanged";
    AndroidTvEvent["Position"] = "position";
    AndroidTvEvent["State"] = "state";
    AndroidTvEvent["TimedMetadataReceived"] = "timedMetadataReceived";
})(AndroidTvEvent || (AndroidTvEvent = {}));
export var CaptionEdgeType;
(function (CaptionEdgeType) {
    CaptionEdgeType[CaptionEdgeType["NONE"] = 0] = "NONE";
    CaptionEdgeType[CaptionEdgeType["OUTLINE"] = 1] = "OUTLINE";
    CaptionEdgeType[CaptionEdgeType["DROP_SHADOW"] = 2] = "DROP_SHADOW";
    CaptionEdgeType[CaptionEdgeType["RAISED"] = 3] = "RAISED";
    CaptionEdgeType[CaptionEdgeType["DEPRESSED"] = 4] = "DEPRESSED";
})(CaptionEdgeType || (CaptionEdgeType = {}));
export var CaptionsSource;
(function (CaptionsSource) {
    CaptionsSource["Default"] = "Default";
    CaptionsSource["System"] = "System";
    CaptionsSource["User"] = "User";
})(CaptionsSource || (CaptionsSource = {}));
export var AndroidAdaptiveBitrateStrategy;
(function (AndroidAdaptiveBitrateStrategy) {
    AndroidAdaptiveBitrateStrategy["DEFAULT"] = "DEFAULT";
    AndroidAdaptiveBitrateStrategy["HEURISTICS"] = "HEURISTICS";
})(AndroidAdaptiveBitrateStrategy || (AndroidAdaptiveBitrateStrategy = {}));
export var AndroidIAPCallbackEvent;
(function (AndroidIAPCallbackEvent) {
    AndroidIAPCallbackEvent["Error"] = "onError";
    AndroidIAPCallbackEvent["ModifySubscriptionResponse"] = "onModifySubscriptionResponse";
    AndroidIAPCallbackEvent["ProductDataResponse"] = "onProductDataResponse";
    AndroidIAPCallbackEvent["PurchaseUpdatesResponse"] = "onPurchaseUpdatesResponse";
})(AndroidIAPCallbackEvent || (AndroidIAPCallbackEvent = {}));
export var AndroidLifecycleMethod;
(function (AndroidLifecycleMethod) {
    AndroidLifecycleMethod["OnPause"] = "onPause";
    AndroidLifecycleMethod["OnResume"] = "onResume";
})(AndroidLifecycleMethod || (AndroidLifecycleMethod = {}));
export const AUDIO_FORMAT_MAP = {
    STEREO: AudioFormat.Stereo,
    SURROUND_5_1: AudioFormat.Dolby51,
    SURROUND_7_1: AudioFormat.Dolby71,
    DOLBY: AudioFormat.DolbyAtmos,
    ...AudioFormat,
};
//# sourceMappingURL=android-tv-types.js.map